module.exports = __webpack_public_path__ + "static/media/done.c228142a.svg";